document.addEventListener('DOMContentLoaded', function() {
  var scrollToTopBtn = document.getElementById("scroll-to-top");

  window.addEventListener("scroll", function() {
    if (window.pageYOffset > 300) {
      scrollToTopBtn.style.display = "block";
    } else {
      scrollToTopBtn.style.display = "none";
    }
  });

  scrollToTopBtn.addEventListener("click", function() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});